import React from 'react'

import { KeyedTokenFields } from '../pathMapping/KeyedTokenFields'
import { barePathCodec } from '../pathMapping/paths'

import { GENERIC_FIELDS } from './genericFields'
import { GenericPathHelp } from './GenericPathHelp'

export const GenericCallMetadataFields = () => (
  <KeyedTokenFields
    field={GENERIC_FIELDS.callMetadataFields}
    label="Call Metadata"
    codec={barePathCodec}
    testIdPrefix="generic-metadata"
    keyPlaceholder="account_tier"
    columnLabels={['Path']}
    addLabel="Add field"
    removeLabel="Remove call metadata field"
    placeholder="customFields[name=account_tier].value"
    help={<GenericPathHelp />}
    caption="Each name is sent on every call, empty when its path has no value, so playbook rules always see the field. Names allow letters, numbers and underscores only, and are matched case-sensitively downstream."
  />
)
